import type { GridOptions } from '../../../components/ui/table';
import { commonGridOptions } from '../../../lib/agGridOptions';
import {
  GRID_PAGE_SIZE,
  GRID_PAGE_SIZE_SELECTOR,
} from '../../../components/shared/agGridCells';
import type { MerchantGridRow } from '../models/types';

export { GRID_PAGE_SIZE, GRID_PAGE_SIZE_SELECTOR };

export const merchantGridOptions = {
  ...commonGridOptions,
  overlayNoRowsTemplate:
    '<span class="text-sm text-muted-foreground">No merchants match the current filters.</span>',
} satisfies GridOptions<MerchantGridRow>;
